import styled from 'styled-components'

import { header } from '../../../styles/z-index'
import { maxmedia, minmedia } from '../../../styles/media-queries'
import { white, bordergray } from '../../../styles/colors'

export const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${bordergray};
  box-shadow: 0 1px 3px -3px rgba(0, 0, 0, 0.2);
  background: ${white};
  z-index: ${header};

  ${maxmedia.xmlarge`
    display: none;
  `}
`

export const LogoContainer = styled.div`
  padding-left: 4%; // match container
  margin-bottom: -120px;
  width: 200px;
`

export const PageNavContainer = styled.div`
  flex-grow: 1; //fill remaining width
  padding-left: 1.5rem;

  ${minmedia.xxlarge`
    padding-left: 3rem;
  `}
`

export const IconNavContainer = styled.div`
  width: 270px; // 9x3
`

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -3; //to make sure assortment dropdown keeps working
  left: 0;
  top: 0;
`


// WEBPACK FOOTER //
// ./src/components/Header/Header/styles.js